import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { withTheme } from 'styled-components';
import AppLauncher from '@rsos/components/capstone/AppLauncher';
import { Box } from '@rsos/components/capstone/base';
import { LayoutContext } from '@rsos/components/capstone/base/Layout';
import {
  EMERGENCY_DATA,
  AUTHENTICATION,
  CAPSTONE,
} from '@rsos/constants/appNames';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { selectIsJVEnabled } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import {
  selectIsLoggedIn,
  selectApplication,
} from '@rsos/sinatra/src/selectors/user';
import determineDataPath from '@rsos/utils/determineDataPath';
import { readMetaTag } from '@rsos/utils/metaTags';
import useIsIRP from '@rsos/utils/useIsIRP';
import StyledSmartLink from '../common/StyledSmartLink';
import EagleViewBanner from './EagleViewBanner/EagleViewBanner';
import PremiumLogo from './PremiumLogo/PremiumLogo';
import RightHandButtonNav from './RightHandButtonNav';

const feAppName = readMetaTag('fe-app-name');

const notFoundPath = '/not-found';
const signUpPath = '/sign-up';

const RSPNavigation = ({ handleLogout, path, persistor }) => {
  const application = useSelector(selectApplication);
  const { layout } = useContext(LayoutContext);
  const isJVEnabled = useSelector(selectIsJVEnabled);
  const { irp_access_token } = useIsIRP();
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isAnchoredPath = path === notFoundPath || path.includes(signUpPath);
  const disableNavBarNavigation = path === notFoundPath;
  const disableLogoNavigation =
    path ===
    determineDataPath(application, isJVEnabled, irp_access_token, isLoggedIn);

  const initialized = useSelector(state => state.app?.initialized);
  const showUniteLogo =
    application === CAPSTONE && feAppName !== AUTHENTICATION;
  const isObliqueImageryClickable = useSelector(
    state => state?.geoSelection?.obliqueImagery?.isClickable,
  );

  return (
    <>
      <Box horizontal align="center">
        <Box flex="0 0 auto">
          <StyledSmartLink
            to={determineDataPath(
              application,
              isJVEnabled,
              irp_access_token,
              isLoggedIn,
            )}
            type="standalone"
            data-name="navigation-logo-link"
            useAnchor={isAnchoredPath}
            disableNavigation={disableLogoNavigation || disableNavBarNavigation}
          >
            <PremiumLogo
              initialized={initialized}
              showUniteLogo={showUniteLogo}
              compact={layout.window.width <= BP_LAPTOP}
            />
          </StyledSmartLink>
        </Box>
        {feAppName === EMERGENCY_DATA && isLoggedIn && (
          <Box horizontal align="center" flex="0 1 auto">
            <AppLauncher />
          </Box>
        )}
      </Box>

      {isObliqueImageryClickable && <EagleViewBanner />}
      {isLoggedIn && !disableNavBarNavigation && (
        <RightHandButtonNav
          persistor={persistor}
          path={path}
          handleLogout={handleLogout}
        />
      )}
    </>
  );
};

export default withTheme(RSPNavigation);
